<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
              <label :class="{'txt-right' : true, 'required' : is_required}">Công ty</label>
              <DropdownScrollable cusClass="m-0 cs-width" :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
              <input class="input-group input_tmp_validator" id="company" />
            </div>
            <div class="mt-2">
              <label :class="{'txt-right' : true, 'required' : is_required}">Nhà thầu</label>
              <DropdownScrollable
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                defaultLabel="label"
                :limit="contractor_obj.limit"
                :loading="contractor_obj.loading"
                v-model="selcontractor"
                :options="contractor_obj.items"
                :total="contractor_obj.total"
                @keyup="emitEventContractor"
                @offset="changeOffsetContractor"
                @scroll="emitEventContractor"
                :disabled="mode=='edit'||isTypeCompany"
              />
              <input class="input_tmp_validator_r" id="contractor_add" />
            </div>
            <div class="mt-2">
              <label class="txt-right">Ảnh</label>
              <input class="input_tmp_validator" id="images">
              <div class="cus-text">Kích thước đề xuất: 500x500px - Dung lượng tối đa: 50 MB</div>
              <div class="cus-text">Định dạng file:: JPG, JPEG, PNG, GIF (không phải ảnh động).</div>
              <input class="p-inputtext p-component cs-input" style="background-color: #EEEEEE;" accept="image/*" name="images[]" type="file" @change="onFileSelect"/>
              <div class="box-images mt-3 cs-input"  v-if="images && images.length">
                <div class="item-img" v-for="(item, index) in images" :key="index" >
                  <div class="button-clear" @click="onFileClear(index)"><img src="../../../assets/ic_clear.svg"/></div>
                  <img :src="item.objectURL" width="80" height="80"/>
                </div>
              </div>
            </div>
            <div class="mt-2" v-show="mode == 'add'">
              <label class="txt-right required">Loại</label>
              <div class="radio-group">
                <div style="display: flex;">
                  <input type="radio" value="supplies" v-model="type" @change="changeType"><span style="margin-left: 5px;"> Vật tư</span>
                </div>
                <div style="display: flex;">
                  <input type="radio" value="equipment" v-model="type" @change="changeType"><span style="margin-left: 5px;"> Thiết bị</span>
                </div>
              </div>
            </div>
            <div class="mt-2" v-show="mode == 'edit'">
              <label class="txt-right">Loại</label>
              <InputText :disabled="mode == 'edit'" v-model="text_type" type="text" class="cs-input input-text-box"/>
            </div>
            <div class="mt-2">
              <label class="txt-right required">Tên gọi</label>
              <InputText v-model="name" id="name_add" type="text" class="input-text-box cs-input" placeholder="Nhập" maxlength="255"/>
            </div>
          </div>
          <div class="f-grid-col">
            <!-- bên phải -->
          </div>
        </div>
        <div class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">HỒ SƠ</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-3">
              <table id="tb_level">
                <tr>
                  <th style="width: 50px;">STT</th>
                  <th style="">Tên hồ sơ</th>
                  <th style="width: 260px;">Danh sách file</th>
                  <th style="width: 90px;">Hiệu lực đến</th>
                  <th style="width:90px">Hành động</th>
                </tr>
                <tr v-for="(item, index) in list_profile" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <div v-if="item.files && item.files.length > 0" class="profile-file-list">
                      <div v-for="(file, fileIndex) in item.files" :key="fileIndex" class="profile-file-row">
                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(file)"/>
                      </div>
                    </div>
                  </td>
                  <td>{{item.expiration_date_text}}</td>
                  <td style="text-align: center;" >
                    <Button
                      @click="ShowUpload(index)"
                      icon="pi pi-upload"
                      class="button-box p-button-add"
                    >
                    </Button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <Checkbox v-model="active" :binary="true" /><span>Hoạt động</span>
            </div>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>

      <Dialog header="Tải tệp" :visible.sync="showEditDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
        <div style="padding-top: 0px;min-width:400px;">
          <div v-if="profile_info">
            <label class="txt-left">Hiệu lực từ</label>
            <Calendar v-model="profile_info.expiration_from" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
            <label class="txt-left">Hiệu lực đến</label>
            <Calendar v-model="profile_info.expiration_date" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
          </div>
          <input class="input_tmp_validator" id="files">
          <div class="cus-text">Dung lượng tối đa: 50 MB</div>
          <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
          <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect2"/>
          <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
            <p>Đang tải lên...</p>
          </div>
          <div class="box-images text-box-a profile-file-list" v-if="profile_info && profile_info.files && profile_info.files.length > 0">
            <div class="profile-file-row" v-for="(item, index) in profile_info.files" :key="index" >
              <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
              <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(item)"/>
              <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear2(index)"/>
              <div v-if="item.is_new" class="profile-file-sync">
                <Checkbox :inputId="'sync_sra_vttb_' + index" v-model="item.sync_sra_vttb" :binary="true"/>
                <label :for="'sync_sra_vttb_' + index">Đồng bộ gói công việc</label>
              </div>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showEditDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
        </template>
      </Dialog>

    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable_v2.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";

export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      is_required : true,
      filters: {},
      maxFileSize: 10485760*5,//1024*1024*50 = 50MB
      maxFiles : 1,
      name: "",
      active: true,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      owner_name : "",
      email : "",
      code : "",
      phone : "",
      maxFilesProfile: 100,
      list_profile : [
        // {
        //   id : 1,
        //   name : "Giấy phép đăng ký kinh doanh",
        //   files : []
        // }
      ],
      profile_info : null,
      showEditDialog : false,
      index_update : -1,
      filesDeletes : [],
      edit_id : null,
      filesDeletes2 : [],
      filesDeletes2_tmp : [],
      selcontractor : null,
      contractor_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      images: [],
      imagesDeletes : [],
      type : 'supplies',
      text_type : 'Vật tư',
    };
  },
  async mounted() {
    await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.is_required = false;
      if (this.$route.params.id !== undefined) this.edit_id = this.$route.params.id;
      this.type = this.model.type;
      if(this.model.type == 'supplies'){
        this.text_type = 'Vật tư'
      }else if(this.model.type == 'equipment'){
        this.text_type = 'Thiết bị'
      }
      this.company = this.model.company;
      this.name = this.model.name;
      this.active = this.model.active;
      this.selcontractor = this.model.contractor
      if (!this.$commonFuction.isEmpty(this.model.list_files) && this.model.list_files.length > 0) {
        let url = this.model.list_files[0].file.url
        let split = url.split('/')
        let fileName = split[split.length - 1]
        let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.images.push(obj);
      }
    }else{
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
      }
    }
  },
  computed: {
    isTypeCompany() {
      if (this.$store.getters.typeCompany) {
        if (this.$store.getters.typeCompany === 'contractor') {
        return true;
        }
      }
      return false;
    },
  },
  watch: {
    // async "company_id"() {
    //   if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
    //     this.company = {id: this.company_id};
    //   }
    // },
    // async "$store.getters.company_id"() {
    //   if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
    //     this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    //     this.company = {id: this.company_id};
    //   }
    // },
    async "company"() {
      if(this.mode == 'add'){
        this.selcontractor = null
      }
      await this.getListDocumentFileAll();
      await this.getListContractor();
      if (this.mode == "edit" && this.loadKey == 0) {
        this.loadKey++;
      }
      if(this.contractor_obj.items.length > 0){
        if(this.mode == 'add' && this.$store.getters.typeCompany == 'contractor'){
          this.selcontractor = this.contractor_obj.items[0]
        }
      }
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Vui lòng chọn công ty!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      let contractor_add = document.getElementById("contractor_add");
      if (this.$commonFuction.isEmptyObject(this.selcontractor)) {
        contractor_add.setCustomValidity("Vui lòng chọn nhà thầu!");
      } else {
        contractor_add.setCustomValidity("");
      }
      let name_add = document.getElementById("name_add");
      if (this.name == undefined || this.name == null || this.name == "") {
        name_add.setCustomValidity("Vui lòng nhập tên gọi!");
      } else {
        name_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        active: this.active,
        company: this.company,
        images: this.images,
        type : this.type,
        contractor : this.selcontractor,
        list_profile : this.list_profile,
        files_deleted : this.filesDeletes2,
      };
      //this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    ShowUpload(index){
      this.index_update = -1;
      const profile = this.list_profile[index];
      this.index_update = index;
      this.profile_info = {
        id : profile.id,
        name : profile.name,
        files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
        document_files_supplies_equipment_id : profile.document_files_supplies_equipment_id ?? null,
        expiration_date : profile.expiration_date ?? null,
        expiration_date_text : profile.expiration_date_text ?? '',
        expiration_from : profile.expiration_from ?? null,
        expiration_from_text : profile.expiration_from_text ?? '',
      }
      this.filesDeletes2_tmp = []
      this.showEditDialog = true
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > 1) {
          alert("Chỉ được upload tối đa 1 ảnh");
          return;
        }
        let acceptTags = ["jpeg","jpg","gif","png","JPEG","JPG","PNG","GIF"];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Vui lòng upload file có định dạng là: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 50MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    async onFileSelect2(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.loading = true;
      if (files.length > 0) {
        if (files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFilesProfile+" file");
          this.loading = false;
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg."
            );
            this.loading = false;
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFilesProfile + " files");
          this.loading = false;
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            // console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          // console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            this.loading = false;
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            console.log("arrTemp===",arrTemp);
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.DOCUMENT_FILES, arrTemp).then((resImage)=> {
              tmp_add = (resImage ?? []).map(item => ({...item, is_new: true, sync_sra_vttb: false}))
            })

            // for (let m = 0; m < tmp_add.length; m++) {
            //   let url = tmp_add[m].url
            //   let split = url.split('/')
            //   let fileName = split[split.length - 1]
            //   tmp_add[m].name = fileName;
            // }
            // console.log("tmp_add=========",tmp_add)
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, tmp_add);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      this.loading = false;
      return;
    },
    async EditData(){
      // console.log("this.profile_info",this.profile_info)
      // console.log("index_update",this.index_update)
      const tmp = this.profile_info
      tmp.expiration_date_text = tmp.expiration_date ? moment(tmp.expiration_date).format("DD/MM/YYYY") : null
      tmp.expiration_from_text = tmp.expiration_from ? moment(tmp.expiration_from).format("DD/MM/YYYY") : null
      if(this.index_update >= 0){
        this.list_profile[this.index_update] = tmp;
      }
      this.showEditDialog = false
      this.profile_info = null;
      // console.log("filesDeletes2_tmp===",this.filesDeletes2_tmp)
      this.filesDeletes2 = this.filesDeletes2.concat(this.filesDeletes2_tmp);
      // console.log("t.list_profile",this.list_profile)
    },
    downloadFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file.name || fileUrl.split("?")[0].split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
    onFileClear2(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file && file.is_old==true) this.filesDeletes2_tmp.push(file.id);
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    isValidPhoneNumber() {
      var phone = this.phone;
      // kiểm tra định dạng số điện thoại
      const phoneRegex = /^\+?[0-9]{10,15}$/;
      return phoneRegex.test(phone);
    },
    
    async getListDocumentFileAll() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.updateListProfile([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var type = 'SUPPLIES_PROFILE'
        if(this.type == 'equipment'){
          type = 'EQUIPMENT_PROFILE'
        }
        await ApiRepository.post("/_api/document_files/all", {type : type ,object_id : this.edit_id, company_id: this.company.id}, {headers}).then((res) => {
            var tmp_df = res.data.data.document_files ?? []
            // console.log("tmp_df===",tmp_df)
            this.updateListProfile(tmp_df)
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    updateListProfile(list=[]){
      var tmp = []
      for (let i = 0; i < list.length; i++) {
        let files = list[i].files ?? []
        let tm = {
          id : list[i].id,
          name : list[i].name,
          document_files_supplies_equipment_id : list[i].document_files_users_id ?? null,
          files : files,
          expiration_date : list[i].expiration_date ? new Date(list[i].expiration_date) : null,
          expiration_date_text : list[i].expiration_date ? moment(list[i].expiration_date).format("DD/MM/YYYY") : null,
          expiration_from : list[i].expiration_from ? new Date(list[i].expiration_from) : null,
          expiration_from_text : list[i].expiration_from ? moment(list[i].expiration_from).format("DD/MM/YYYY") : null,
        }
        tmp.push(tm)
      }
      //console.log("tmp===",tmp)
      this.list_profile = tmp
    },
    emitEventContractor(keyword) {
      console.log(keyword);
      this.$delete(this.contractor_obj.filters, 'filter_txt');
      if (keyword) {
        this.contractor_obj.filters.filter_txt = keyword;
      }
      this.getListContractor();
    },
    changeOffsetContractor(value) {
      this.contractor_obj.offset = value;
    },
    async getListContractor() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.contractor_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.contractor_obj.loading = true;
        await ApiRepository.post("/_api/contractor/options", {filters: this.contractor_obj.filters, limit: this.contractor_obj.limit, offset: this.contractor_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.contractor_obj.offset > 0 ) {
              this.contractor_obj.items.push(...res.data.data.contractor);
            } else{
              this.contractor_obj.items = res.data.data.contractor;
            }
            this.contractor_obj.total = res.data.data.count;
            this.contractor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.contractor_obj.loading = false;
        })
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    changeType(){
      this.getListDocumentFileAll();
    },
    async viewFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const fileName = file.name || fileUrl.split("?")[0].split("/").pop() || "";
      const extension = fileName.toLowerCase().split(".").pop();
      const imageMimeTypes = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        bmp: "image/bmp",
        svg: "image/svg+xml",
        tif: "image/tiff",
        tiff: "image/tiff",
      };
      const isPdf = extension === "pdf";
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension);

      if (!isPdf && !isImage) {
        window.open(fileUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.");
        return;
      }

      previewWindow.opener = null;

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
          throw new Error(`Không thể tải file (${response.status})`);
        }

        const blob = await response.blob();
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension];
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType });
        const blobUrl = URL.createObjectURL(previewBlob);

        previewWindow.location.href = blobUrl;
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval);
            URL.revokeObjectURL(blobUrl);
          }
        }, 5 * 1000);
      } catch (e) {
        previewWindow.close();
        console.error("Lỗi xem file:", e);
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.");
      }
    },
  },
  
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 6px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel-2 {
  color : #333333;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.profile-file-list {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.profile-file-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}
.profile-file-link {
  display: block;
  max-width: 100%;
  color: #0086C4;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.profile-file-sync {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  white-space: nowrap;
  label { margin: 0; cursor: pointer; }
}
.radio-group {
  display: flex; /* Sử dụng flexbox để đặt chúng cùng hàng */
  gap: 40px; /* Khoảng cách giữa các radio button */
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
